import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  public mainUrl = 'https://dev-app.primasales.de/api';
  //public mainUrl = "http://192.168.178.87:443/api";
  //public mainUrl = "http://192.168.188.43:8080/api";
  //public mainUrl = "http://192.168.188.51:443/api";

  constructor(private http: HttpClient) {}

  // --- Typed generic methods (Story 3-2) ---

  get<T>(path: string): Promise<T> {
    return firstValueFrom(this.http.get<T>(this.mainUrl + path));
  }

  post<T>(path: string, data: unknown): Promise<T> {
    return firstValueFrom(this.http.post<T>(this.mainUrl + path, data));
  }

  put<T>(path: string, data: unknown): Promise<T> {
    return firstValueFrom(this.http.put<T>(this.mainUrl + path, data));
  }

  patch<T>(path: string, data: unknown): Promise<T> {
    return firstValueFrom(this.http.patch<T>(this.mainUrl + path, data));
  }

  delete<T>(path: string): Promise<T> {
    return firstValueFrom(this.http.delete<T>(this.mainUrl + path));
  }

  getExternal<T>(url: string): Promise<T> {
    return firstValueFrom(this.http.get<T>(url));
  }

  postFormData<T>(path: string, formData: FormData): Promise<T> {
    return firstValueFrom(this.http.post<T>(this.mainUrl + path, formData));
  }

  postText(path: string, data: unknown): Promise<string> {
    return firstValueFrom(this.http.post(this.mainUrl + path, data, { responseType: 'text' }));
  }
}
